import React, { useState, useEffect } from 'react';
import './ProductosMenu.scss'
import { IoIosArrowForward } from 'react-icons/io'
import ProductosSubMenu from './ProductosSubMenu'
import { useNavigate } from "react-router-dom";
import { connect } from 'react-redux'
import { setSelectedCategory, setProductsTable, setAllProducts, pushFilters, resetFilters, setPaginationState, showSpinner } from '../actions'
import { CategoryFilter } from '../filters/CategoryFilter'
import { scrollBodyTop } from '../hooks/scrollPosition';
import { getProducts } from '../hooks/gets';
import { ScheurichLogo } from '../utils/icons';
import { DeromaLogo } from '../utils/icons';
import { PreChangeBrandChosen } from '../hooks/config';
import { BRANDCHOSEN } from '../hooks/config';
import { PopupOneButton } from './PopupOneButton';

const ProductosMenu = (props) => {
console.log("props productosMenu", props);
    const { menu, closeMenu, onClick } = props

    const [submenuToShow, setSubmenuToShow] = useState(null)
    const [submenuTop, setSubmenuTop] = useState(0)
    const [submenuHeight, setSubmenuHeight] = useState(0)
    const [menuCategories, setMenuCategories] = useState([])
    const [categorySelected, setCategorySelected] = useState(null)
    const [showPopupPresupuestosPendientes, setShowPopupPresupuestosPendientes] = useState(false)
    const [brandPreChosen, setBrandPreChosen] = useState(BRANDCHOSEN)

    const navigate = useNavigate();

    useEffect(() => {
        console.log("menuCategories", menuCategories);
        if (menu) {
            setMenuCategoriesOrdered(BRANDCHOSEN).then((res) => {
                console.log("Categorías cargadas:", res);
            });
        } else {
            console.log("No hay categorías para la marca:", BRANDCHOSEN);
        }
    }, [])

    const setMenuCategoriesOrdered = ((marca = 'fansa') => {
        return new Promise((res) => {
            console.log("menu recibido:", menu);
console.log("marca usada:", marca);
console.log("menu[marca]:", menu);

            if (menu) {
                const menuOrder = menu[marca].sort((a, b) => {
                    return a.Position - b.Position;
                })
                setMenuCategories(menuOrder)
            }
            res()
        })
    })

    const handleArroyClick = async (item, index) => {
        // props.showSpinner(true)
        // if (props.productsTable !== 'allProducts') {
        //     getProducts().then(async res => {
        //         await props.setAllProducts(res.data)
        //         configCategoryAndCollection(item, index)
        //     }).catch(err => {
        //         props.showSpinner(false)
        //     })
        // } else {
        configCategoryAndCollection(item, index)
        // }
    }

    const configCategoryAndCollection = async (item, index) => {
        // props.setPaginationState(1)
        // props.setProductsTable('allProducts')
        // const categoryFilter = new CategoryFilter(item.Name)
        // await props.setSelectedCategory({
        //     categoryId: item.ID,
        //     subtitle: item.Name,
        //     img: item.ImgBanner,
        //     selectedCollection: ''
        // })
        // props.resetFilters()
        // await props.pushFilters(categoryFilter)
        setCategorySelected(item)
        if (submenuToShow === null) {
            setSubmenuToShow(item.Collections.sort())
        } else {
            setSubmenuToShow(null)
        }
        /* eslint-disable no-restricted-globals */
        const screenHeight = screen.height;
        /* eslint-enable no-restricted-globals */
        const contentHeight = document.getElementsByClassName('menu-item-container')[0].clientHeight
        let top = (index * contentHeight)
        let height = screenHeight - top - 200
        setSubmenuHeight(height)
        setSubmenuTop(top)
    }

    const handleMenuClick = async (to, item) => {
        changeBrandGlobal().then(async (brandChanged) => {
            if (brandChanged == true) {
                props.showSpinner(true)
                // if (props.productsTable !== 'allProducts') {
                getProducts().then(async res => {
                    console.log("handleMenuClick chnageBrandGlobal getPrpducts", res)
                    await props.setAllProducts(res)
                    configCategory(to, item)
                }).catch(err => {
                    props.showSpinner(false)
                })
                // } else {
                //     configCategory(to, item)
                // }
            }
        })
    }

    const configCategory = async (to, item) => {
        props.setPaginationState(1)
        props.setProductsTable('allProducts')
        const categoryFilter = new CategoryFilter(item.Name)
        await props.setSelectedCategory({
            categoryId: item.ID,
            subtitle: item.Name,
            img: item.ImgBanner,
            selectedCollection: ''
        })
        props.resetFilters()
        await props.pushFilters(categoryFilter)
        closeMenu()
        onClick()
        setSubmenuToShow(null)
        setSubmenuTop(0)
        scrollBodyTop()
        navigate(to);
    }

    // const handleClickEnd = async () => {
    //     setShowPopupPresupuestosPendientes(false)
    //     closeMenu()
    // }


    const changeBrandGlobal = () => {
        return new Promise(async (resolve) => {
            let marcaCambiada = await PreChangeBrandChosen(brandPreChosen, props.budget)
            if (!marcaCambiada) {
                setShowPopupPresupuestosPendientes(true)
                resolve(false)
            } else {
                resolve(true)
            }
        })
    }

    const handleChangeBrandClick = async (marca) => {
        setMenuCategoriesOrdered(marca)
        setBrandPreChosen(marca)
    }

    return (
        <div className="productos-menu-container-top">
            {showPopupPresupuestosPendientes &&
                <PopupOneButton title="¡Presupuestos pendientes!" text="Tienes presupuestos pendientes, para cambiar de marca debes guardar o eliminar los presupuestos." textButton="Aceptar" onClick={() => setShowPopupPresupuestosPendientes(false)} />
            }

            <div className="productos-menu-container">
                {
                    menuCategories !== undefined && menuCategories.length > 0 &&
                    <div>
                        <div className="menu-item-container">
                            <div className="menu-item-content">
                                <div className="menu-item">
                                    <div className="menu-item-text menu-item-img" onClick={() => handleChangeBrandClick(`fansa`)}>
                                        <DeromaLogo size={60} />
                                    </div>
                                    <div className="menu-item-arrow">
                                        <div className={brandPreChosen == 'fansa' ? 'sub-menu-show' : ''} onClick={() => handleChangeBrandClick('fansa')}><IoIosArrowForward /></div>
                                        {/* <div className={submenuToShow !== null && item.Name === categorySelected.Name ? 'sub-menu-show' : ''} onClick={() => handleArroyClick(item, index)}><IoIosArrowForward /></div> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="menu-item-container">
                            <div className="menu-item-content">
                                <div className="menu-item">
                                    <div className="menu-item-text menu-item-img" onClick={() => handleChangeBrandClick(`scheurich`)}>
                                        <ScheurichLogo size={40} />
                                    </div>
                                    <div className="menu-item-arrow">
                                        <div className={brandPreChosen == 'scheurich' ? 'sub-menu-show' : ''} onClick={() => handleChangeBrandClick('scheurich')}><IoIosArrowForward /></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>


            <div className="productos-menu-container">
                {
                    menuCategories !== undefined && menuCategories.length > 0 && menuCategories.map((item, index) => {
                        return (
                            <div className="menu-item-container" key={item.ID}>
                                <div className="menu-item-content">
                                    <div className="menu-item">
                                        <div className="menu-item-text">
                                            <div onClick={() => handleMenuClick(`/categoria/${item.ID}`, item)}>
                                                {item.Name === 'Nuevo' ?
                                                    <p>Novedades</p>
                                                    :
                                                    <p>{item.Name[0].toUpperCase() + item.Name.slice(1).toLowerCase()}</p>
                                                }
                                            </div>
                                        </div>
                                        <div className="menu-item-arrow">
                                            <div className={submenuToShow !== null && item.Name === categorySelected.Name ? 'sub-menu-show' : ''} onClick={() => handleArroyClick(item, index)}><IoIosArrowForward /></div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    submenuToShow != null && item.Name === categorySelected.Name &&
                                    <div onClick={onClick} className="submenu-container menu-mobile">
                                        <ProductosSubMenu
                                            closeMenu={closeMenu}
                                            menu={submenuToShow}
                                            category={categorySelected}
                                            brandPreChosen={brandPreChosen}
                                            setShowPopupPresupuestosPendientes={(show) => { setShowPopupPresupuestosPendientes(show) }}
                                        />
                                    </div>
                                }
                            </div>
                        )
                    })
                }
                {
                    submenuToShow != null &&
                    <div onClick={onClick} className="submenu-container menu-desktop"
                        style={{
                            top: `calc(-0.5rem + 2vw + ${submenuTop}px)`,
                            maxHeight: `calc(${submenuHeight}px - 1rem - 1vw)`
                        }}
                    >
                        <ProductosSubMenu
                            closeMenu={closeMenu}
                            menu={submenuToShow}
                            category={categorySelected}
                            height={`calc(${submenuHeight}px - 1rem - 1vw)`}
                            brandPreChosen={brandPreChosen}
                            setShowPopupPresupuestosPendientes={(show) => { setShowPopupPresupuestosPendientes(show) }}
                        />
                    </div>
                }

            </div>

        </div>
    )
}

const mapDispatchToProps = {
    setSelectedCategory,
    setProductsTable,
    setAllProducts,
    pushFilters,
    setPaginationState,
    resetFilters,
    showSpinner
}

const mapStateToProps = state => state

export default connect(mapStateToProps, mapDispatchToProps)(ProductosMenu)